<template>
  <a
    v-bind="$attrs"
    role="button"
    class="inline-flex items-center justify-center gap-x-2 rounded-lg bg-neutral-50 px-6 py-4 font-bold leading-normal text-neutral-900 no-underline"
  >
    <slot />
  </a>
</template>
